import script from "./app.vue?vue&type=script&lang=ts&setup=true"
export * from "./app.vue?vue&type=script&lang=ts&setup=true"

import "./app.vue?vue&type=style&index=0&id=38235ff6&lang=scss"

const __exports__ = script;

export default __exports__